// extracted by mini-css-extract-plugin
module.exports = {"header":"style_header__2lGhW","logo":"style_logo__3s9eD"};